import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { buildStyleObj, buildStyles, matchStyle } from 'Components/ComponentLibrary/DesignSystem/utils';
import ListItem1 from 'Components/ComponentLibrary/Components/ListItems/ListItem1';
import { getBorderRadius } from 'Components/utils';
import { darken } from '@material-ui/core/styles/colorManipulator';

const ROOT_COLOR_PREFIX = 'rootColor';

export const COLORS = [
  'lightGray5',
  'clear',
  'accentBlue20',
  'accentYellow1',
  'brightRed12',
];

const styles = theme => ({
  root: {
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  ...buildStyles(COLORS.map((color) => {
    return buildStyleObj(color, { backgroundColor: theme.palette.facet[color] });
  }), ROOT_COLOR_PREFIX, (config) => {
    return {
      backgroundColor: config.backgroundColor,
      '&:hover': {
        backgroundColor: darken(config.backgroundColor, 0.04),
      },
    };
  }),
});

const ListItem2 = React.forwardRef(
  ({
    classes,
    className,
    color,
    ...rest
  }, ref) => {
    return (
      <ListItem1
        className={classNames(
          className,
          classes.root,
          matchStyle(classes, COLORS, ROOT_COLOR_PREFIX, color),
        )}
        ref={ref}
        {...rest}
      />
    );
  },
);

ListItem2.defaultProps = {
  className: '',
  color: 'clear',
};

ListItem2.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
};
export default withStyles(styles)(ListItem2);
